const assetsLinks = {
  politique:
    "https://docs.google.com/document/d/1FGeSunezNzelahKaLTambUAoQKTJa738qU2zfJk03cM/edit?usp=sharing",
};

export default assetsLinks;
